module.exports = __webpack_public_path__ + "static/media/safari_128x128.773bbab0.png";